export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-white rounded-t-3xl">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <h3 className="text-2xl md:text-3xl font-heading font-bold mb-3">订阅爆料速递</h3>
            <p className="text-foreground-300 text-sm mb-5 leading-relaxed">
              第一时间获取网红翻车、娱乐圈内幕与反差视频精选。深夜吃瓜，51每日大赛与你同在。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <div className="flex-1 border-b border-foreground-500 pb-2">
                <input
                  type="email"
                  placeholder="输入你的邮箱地址"
                  className="w-full bg-transparent text-white text-sm outline-none placeholder:text-foreground-500"
                  readOnly
                />
              </div>
              <button className="px-6 py-2.5 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-foreground-100 transition-all duration-200 whitespace-nowrap cursor-pointer" type="button">
                订阅
                <i className="ri-arrow-right-line ml-1.5"></i>
              </button>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">快速链接</h4>
            <div className="flex flex-col gap-3">
              <a href="#faq" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">吃瓜必读FAQ</a>
              <a href="#ranking" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">今日热度榜</a>
              <a href="#updates" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">24小时实时快讯</a>
              <a href="#contact" className="text-sm text-foreground-400 hover:text-white transition-colors duration-200 cursor-pointer">爆料投稿</a>
            </div>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-sm font-semibold mb-4 text-foreground-200">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-foreground-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-400"></i>
                <span>tips@51daily.com</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                <span>400-888-5151</span>
              </div>
              <div className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5"></i>
                <span>北京市朝阳区望京SOHO T2 15层</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-white transition-colors duration-200">微博</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-white transition-colors duration-200">微信公众号</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-white transition-colors duration-200">抖音</span>
          </div>
          <p className="text-xs text-foreground-500 text-center">
            &copy; {new Date().getFullYear()} 51每日大赛. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-white transition-colors duration-200">隐私政策</span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-white transition-colors duration-200">使用条款</span>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-white/10">
          <h4 className="text-sm font-semibold mb-4 text-foreground-200">合作伙伴</h4>
          <div className="h-8"></div>
        </div>
      </div>
    </footer>
  );
}